import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'profile-badge',
    templateUrl: './profile-badge.template.html',
    styleUrls: ['./profile-badge.style.scss'],
})
export class ProfileBadgeComponent {
    @Input('badge') badge: any;
    @Input('count') count = 0;

    constructor(private sanitizer: DomSanitizer) {}

    get badgeName(): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(this.badge.name);
    }
}
